var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUruguay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 22.792,
    viewBox: "0 0 3.457 1.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M.002-.018h3.453v1.965H.002Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#33348e",
    fillRule: "evenodd",
    d: "M1.287.23h2.167v.243H1.287ZM0 1.213h3.453v.246H0ZM1.287.721h2.167v.243H1.287Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "M.627.424.505.458C.517.346.472.368.47.298.47.224.371.26.451.13.44.236.52.215.526.3.53.382.604.32.627.424z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m.575.437-.07.021C.517.346.472.368.47.298.47.224.371.26.451.13c-.045.11.047.086.051.17.005.083.05.034.073.136z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "M.735.482.627.414C.72.348.672.329.725.28.778.231.685.182.834.156.748.216.818.263.759.32.7.381.795.396.735.481z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.684.441.627.414C.72.348.672.329.725.28.778.231.685.182.834.155.727.2.796.247.737.305.68.365.743.357.684.441z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "M.776.592.744.47c.113.015.09-.031.161-.03.073 0 .04-.1.166-.016C.968.407.986.488.902.492c-.083.003-.023.08-.126.1z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m.765.528-.02-.06c.112.016.089-.03.16-.03.073 0 .04-.1.166-.015C.961.38.981.462.897.465.814.468.867.507.765.528z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "M.71.67.795.574c.048.104.075.06.113.12.04.06.105-.021.105.13C.968.729.91.789.862.72.813.653.782.744.71.67z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.757.626.795.575c.048.104.075.06.113.12.04.06.105-.021.105.13C.987.71.93.77.88.703.834.635.831.7.757.626z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "m.608.728.12-.045c-.005.114.04.088.046.16.007.072.103.03.031.16C.811.901.732.926.72.844.71.761.64.827.608.728Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.672.71.728.684c-.005.114.04.088.046.16.007.072.103.03.031.16C.836.893.757.92.746.836.736.753.702.81.672.711z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "m.537.654.097.082C.534.79.577.814.518.855.458.896.544.958.392.963.486.916.424.86.49.81.556.758.464.73.537.654z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m.582.7.052.036C.534.79.577.814.518.855.458.896.544.958.392.963.506.934.442.88.509.828.576.778.51.776.582.7z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "m.475.561.041.12C.402.674.427.719.356.723.285.728.325.825.191.751.297.76.273.68.356.67.439.66.374.59.475.561z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m.49.624.026.057C.402.674.427.719.356.723.285.728.325.825.191.751.304.785.28.704.363.696.445.686.389.652.49.624z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "M.533.475.458.578C.398.482.377.528.332.473.286.417.23.507.213.356c.055.09.106.023.163.085.055.062.076-.03.157.034z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.49.524.458.578C.398.482.377.528.332.473.286.417.23.507.213.356c.04.11.089.044.144.106C.414.524.41.458.49.524z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "M.571.72h.102l-.05.372Z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.62.72h.053l-.05.372Z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "M.684.715.756.643l.217.29Z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.721.68.756.644.984.94z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "M.76.634V.53l.368.05z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.76.583V.53l.368.05z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.00408,
    d: "M.746.522.684.458.98.221Z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.715.49.685.458.98.218Z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "M.571.445h.102L.623.06Z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.571.445H.62L.622.06Z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "M.488.52.561.45.248.214Z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.488.52.526.485l-.28-.27Z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "M.485.634V.53l-.363.05Z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.485.634V.582H.122Z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "M.561.715.488.643.256.935Z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.561.715.521.68.257.94Z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff22d",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.001536,
    d: "M.623.41c.095 0 .173.078.173.173a.174.174 0 0 1-.173.173A.174.174 0 0 1 .45.583C.45.488.53.41.623.41z",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.002048,
    d: "M.608.685c.014.002.023 0 .038 0C.664.68.677.672.695.667.699.667.698.67.694.672.68.676.666.685.646.688a.153.153 0 0 1-.039 0C.604.689.601.686.608.686z",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.0025440000000000003,
    d: "M.558.658C.55.658.55.668.554.667a.276.276 0 0 0 .137 0C.698.668.701.66.692.66A.256.256 0 0 1 .558.658z",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.003056,
    d: "M.507.518A.174.174 0 0 1 .55.511c.01 0 .027.005.04.009C.593.52.594.517.59.516a.13.13 0 0 0-.04-.01.193.193 0 0 0-.045.009C.502.516.503.52.506.518zm.244 0A.174.174 0 0 0 .708.511C.697.511.681.516.668.52.665.52.664.517.667.516a.13.13 0 0 1 .04-.01c.013 0 .034.005.045.009.004.001.003.006 0 .003zM.511.484A.155.155 0 0 1 .598.5C.602.503.604.5.599.5a.112.112 0 0 0-.04-.017A.178.178 0 0 0 .51.48C.507.482.507.485.511.484zm.23.002a.217.217 0 0 0-.046.002C.683.49.667.498.655.503.65.507.648.503.652.501a.109.109 0 0 1 .04-.017.223.223 0 0 1 .049-.001c.003 0 .003.004 0 .003z",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.613,
    strokeWidth: 0.004592,
    d: "M.002-.018h3.453v1.965H.002Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#33348e",
    fillRule: "evenodd",
    d: "M0 1.701h3.456v.246H0Z",
    clipRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.554.511c.012 0 .02.006.02.013 0 .006-.008.012-.02.012C.541.536.532.53.532.524c0-.007.01-.013.022-.013zm.154 0C.697.51.687.515.687.522s.01.012.021.012C.72.535.73.53.73.523S.72.51.71.51zM.57.61C.573.62.59.615.594.62c.003.002.028.002.04-.006C.638.614.638.611.637.61a.047.047 0 0 1-.043.004C.585.608.58.609.577.608.573.605.574.598.582.588c.002-.004 0-.009-.005 0A.032.032 0 0 0 .57.61z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUruguay);
export default __webpack_public_path__ + "static/media/uruguay.2f6f38f25c358ca501ce3d2f68f30cd9.svg";
export { ForwardRef as ReactComponent };